module.exports = __webpack_public_path__ + "static/assets/19b43c71485303c8ba1867ae1dba07fe.svg";